import { useEffect } from "react";

// Games are opened as a fresh webview with no prior SPA history, so the
// device/webview back action has nothing to pop to and exits the app
// entirely. This traps that back action and dismisses the webview back to
// the native app instead.
export function useGameBackNavigation() {
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      window.location.href = "https://goqii.com/app?dismiss=Y";
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);
}
